import {cookieBanner, type CookieBanner} from "../index.js";
import type {NexusHandler} from "@otto-ec/global-resources/nexus";
import {AppType, appType} from "../../global/appInfo.js";

export const resurface: NexusHandler<CookieBanner["resurface"]> = () => {
    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.onCookieBannerResurface?.()
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onCookieBannerResurface?.postMessage({});
    }
};

export const openPreferenceCenter: NexusHandler<CookieBanner["openPreferenceCenter"]> = (data) => {
    if (appType() == AppType.ANDROID) {
        try {
            window.o_apps_android?.onOpenPreferenceCenter?.(data.error);
        } catch {
            window.o_apps_android?.onOpenPreferenceCenter?.();
        }
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onOpenPreferenceCenter?.postMessage(data.error)
    }
};

export const optOutAll: NexusHandler<CookieBanner["optOutAll"]> = (data) => {
    if (appType() == AppType.ANDROID) {
        try {
            window.o_apps_android?.onOptOutAllVendors?.(data.success, data.error);
        } catch {
            window.o_apps_android?.onOptOutAllVendors?.();
        }
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onOptOutAllVendors?.postMessage(data)
    }
};

export const optOutGeneralVendor: NexusHandler<CookieBanner["optOutGeneralVendor"]> = (data) => {
    if (appType() == AppType.ANDROID) {
        try {
            window.o_apps_android?.onOptOutGeneralVendor?.(data.vendorId, data.success, data.error);
        } catch {
            window.o_apps_android?.onOptOutGeneralVendor?.(data.vendorId);
        }

    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onOptOutGeneralVendor?.postMessage(data);
    }
};

cookieBanner.assignNamespace({resurface, openPreferenceCenter, optOutAll, optOutGeneralVendor})
